// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3DIzY","errorLogs":"styles_errorLogs__iNlFD"};